import React from 'react';

import SelectSingleFilterPlain from './SelectSingleFilterPlain';
import SelectSingleFilterPopup from './SelectSingleFilterPopup';

const SelectSingleFilter = ({ showAsPopup = false, initialValues, ...rest }) => {
  return showAsPopup ? (
    <SelectSingleFilterPopup initialValues={initialValues} {...rest} />
  ) : (
    <SelectSingleFilterPlain initialValues={initialValues} {...rest} />
  );
};

export default SelectSingleFilter;
